import Button from 'components/Button'
import TableSearchFilter from 'components/UIComponents/TableSearchFilter'
import { getRoleList } from 'modules/Drives/actions'
import DriveStatusFilter from 'modules/Exp-Candidates/Components/DriveTable/Drivefilter/Partials/DriveStatusFilter/index'
import {
  MenuFlex,
  StyledTab,
  SubmitFlex,
} from 'modules/Exp-Candidates/Components/DriveTable/Drivefilter/Style/style'
import React, { useEffect, useState } from 'react'
import { useDispatch } from 'react-redux'

const DriveFilter = ({
  driveRoles,
  setDriveRoles,
  driveMode,
  setDriveMode,
  driveStatus,
  setDrivestatus,
  searchValue,
  setSearchValue,
  filteApplied,
  corporateStatus,
  currentCount,
  totalCount,
}) => {
  const dispatch = useDispatch()
  const [isMenuOpen, setIsMenuOpen] = useState(false)

  const [roleDetails, setRoleDetails] = useState({
    result: [],
    count: 0,
  })
  const [currentPage, setCurrentPage] = useState(0)
  const [filterData, setFilterData] = useState({})

  const onCancelFilter = () => {
    setDriveMode(filterData?.mode)
    setDrivestatus(filterData?.status)
    setDriveRoles(filterData?.role)
    setIsMenuOpen(!isMenuOpen)
  }

  const onChangeFilet = () => {
    setFilterData({
      ...filterData,
      mode: driveMode,
      status: driveStatus,
      role: driveRoles,
    })
    filteApplied()
    setIsMenuOpen(!isMenuOpen)
  }

  const loadMoreData = async () => {
    let response = await dispatch(getRoleList(currentPage))
    if (response?.status >= 200 && response?.status <= 300) {
      let { count, result } = response?.data?.data || {}
      setRoleDetails({
        count,
        result: [...(roleDetails?.result || []), ...result],
      })
      setCurrentPage(currentPage + 1)
    }
  }

  useEffect(() => {
    loadMoreData()
  }, [])

  let filerItem = [
    {
      label: 'Status',
      key: '3',
      children: (
        <DriveStatusFilter
          driveStatus={driveStatus}
          setDrivestatus={setDrivestatus}
        />
      ),
    },
  ]

  const menu = (
    <MenuFlex column>
      <StyledTab
        border={true}
        tabPosition={'left'}
        type="card"
        items={
          corporateStatus === 'ONGOING'
            ? filerItem?.filter(data => data?.label !== 'Status')
            : filerItem
        }
      />
      <SubmitFlex right>
        <Button.Secondary text="Cancel" onClick={onCancelFilter} />
        <Button.Primary text="Apply Filter" onClick={onChangeFilet} />
      </SubmitFlex>
    </MenuFlex>
  )

  return (
    <TableSearchFilter
      menu={menu}
      open={isMenuOpen}
      setOpen={setIsMenuOpen}
      onOpenChange={() => setIsMenuOpen(!isMenuOpen)}
      searchValue={searchValue}
      setSearchValue={setSearchValue}
      currentCount={currentCount}
      totalCount={totalCount}
    />
  )
}

export default DriveFilter
